export const APP_BREAKPOINTS = {
  min: 280,
  extraSmall: 360,
  small: 480,
  medium: 560,
  large: 720,
  xlarge: 960,
  max: 1140,
};
